import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { SessionProvider, useSession } from './lib/session.js';
import { LoginPage } from './pages/LoginPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { EventListPage } from './pages/EventListPage.js';
import { EventEditPage } from './pages/EventEditPage.js';
import { EntriesPage } from './pages/EntriesPage.js';

/** 管理画面のルーティング。利用者は管理者だけ。 */
function Shell(): JSX.Element {
  const { user, loading, logout } = useSession();

  if (loading) return <div className="login">読み込み中…</div>;
  if (!user) return <LoginPage />;

  return (
    <div className="layout">
      <nav className="sidebar">
        <div className="sidebar__brand">イベント管理</div>
        <NavLink className="sidebar__link" to="/" end>
          効果測定
        </NavLink>
        <NavLink className="sidebar__link" to="/events">
          イベント
        </NavLink>
        <NavLink className="sidebar__link" to="/entries">
          抽選結果
        </NavLink>

        <div className="sidebar__user">
          {user.name}
          <br />
          {user.email}
          <br />
          <button
            type="button"
            className="btn btn--ghost"
            style={{ marginTop: 8, color: '#efe8e1', borderColor: '#5a5149' }}
            onClick={() => void logout()}
          >
            ログアウト
          </button>
        </div>
      </nav>

      <main className="main">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/events" element={<EventListPage />} />
          <Route path="/events/new" element={<EventEditPage />} />
          <Route path="/events/:id" element={<EventEditPage />} />
          <Route path="/entries" element={<EntriesPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App(): JSX.Element {
  return (
    <SessionProvider>
      <Shell />
    </SessionProvider>
  );
}
